import { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Button,
  Divider,
  Fade,
  Grid,
  Breadcrumbs,
  Link,
  Card
} from '@material-ui/core';
import { ArrowBack, Dashboard } from '@material-ui/icons';
// import { dashboardData } from './dashboard-data';
import MetricCard from './MetricCard';
import MetricDetail from './MetricDetails';
import { useDashboardData } from './useDashboardData';

const ManagementDash = () => {
  const dashboardData = useDashboardData();
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeMetric, setActiveMetric] = useState(null);
  const cards = activeCategory ? activeCategory.children || [] : dashboardData;

  /* eslint-disable no-nested-ternary */
  return (
    <Card>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{ bgcolor: 'background.paper', borderBottom: 1, borderColor: 'divider' }}
      >
        <Toolbar sx={{ maxWidth: 1200, width: '100%', mx: 'auto', px: { xs: 2, md: 3 } }}>
          <img src="/assets/images/logo.svg" alt="ZIMTA" style={{ height: 32 }} />
          <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
          <Dashboard sx={{ color: 'primary.main', mr: 1, fontSize: 20 }} />
          <Typography variant="h6" color="text.primary" sx={{ flexGrow: 1, fontSize: '1rem' }}>
            Executive Dashboard
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
            Q4 2025 · Last updated Mar 28
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ py: 4, px: 3, width: '100%' }}>
        <Box sx={{ mb: 3, minHeight: 40, display: 'flex', alignItems: 'center' }}>
          {activeCategory ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Button
                startIcon={<ArrowBack />}
                onClick={() => {
                  if (activeMetric) setActiveMetric(null);
                  else setActiveCategory(null);
                }}
                size="small"
                color="inherit"
                sx={{ color: 'text.secondary' }}
              >
                Back
              </Button>
              <Breadcrumbs sx={{ ml: 1 }}>
                <Link
                  underline="hover"
                  color="text.secondary"
                  sx={{ cursor: 'pointer', fontSize: 14 }}
                  onClick={() => {
                    setActiveCategory(null);
                    setActiveMetric(null);
                  }}
                >
                  Overview
                </Link>
                {activeMetric ? (
                  <Link
                    underline="hover"
                    color="text.secondary"
                    sx={{ cursor: 'pointer', fontSize: 14 }}
                    onClick={() => setActiveMetric(null)}
                  >
                    {activeCategory.title}
                  </Link>
                ) : (
                  <Typography color="text.primary" fontSize={14} fontWeight={600}>
                    {activeCategory.title}
                  </Typography>
                )}
                {activeMetric && (
                  <Typography color="text.primary" fontSize={14} fontWeight={600}>
                    {activeMetric.title}
                  </Typography>
                )}
              </Breadcrumbs>
            </Box>
          ) : (
            <Typography variant="subtitle2" color="text.secondary">
              Overview
            </Typography>
          )}
        </Box>

        <Fade in key={activeMetric?.id || activeCategory?.id || 'root'} timeout={400}>
          <Box>
            {activeMetric ? (
              <MetricDetail data={activeMetric} />
            ) : (
              <Grid container spacing={3}>
                {cards.map((card) => {
                  const drillsToChildren = !!(card.children && card.children.length);
                  const isLeafMetric = !!activeCategory && !drillsToChildren;
                  return (
                    <Grid item xs={12} md={6} key={card.id}>
                      <MetricCard
                        data={card}
                        hasChildren={drillsToChildren || isLeafMetric}
                        onClick={
                          drillsToChildren
                            ? () => setActiveCategory(card)
                            : isLeafMetric
                            ? () => setActiveMetric(card)
                            : undefined
                        }
                      />
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </Box>
        </Fade>
      </Box>
    </Card>
  );
};

export default ManagementDash;
